import axios from 'axios'
import { Modal, message } from 'antd'

const DeletePresentationSlot = (props) => {
    const { id } = props.data

    const handleOk = () => {
        axios.post('/admin/event_slot/delete', {
            event_slot_id: id
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    message.success('删除成功！')
                    props.isCancel()
                    props.getSlotData()
                } else {
                    message.error(response.msg || '操作失败')
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    return (
        <Modal
            title="删除宣讲会资源"
            open={props.isOpen}
            onOk={handleOk}
            onCancel={props.isCancel}
            cancelText="取消"
            okType='danger'
            okText='删除'>

            <p>正在将当前宣讲会资源从列表中移除，此操作不可逆，是否确认删除？
            </p>
        </Modal>
    )
}

export default DeletePresentationSlot
